module.exports = {
  name: '特定假日/工作日資料',
  schema: {
    type: 'Object',
    contents: {
      name: { type: 'String', name: '名稱' },
      date: { type: 'Date', name: '日期' },
      type: {
        type: 'String',
        name: '類別',
        options: ['workday', 'holiday', 'leave', 'dayoff'],
        formatter: (() => {
          const dic = {
            workday: '工作日',
            holiday: '國定假日',
            leave: '例假日',
            dayoff: '休息日',
          }
          return (option) => dic[option]
        })(),
      },
    },
  },
  index: {
    date: {
      key: { date: 1 },
      unique: true,
    },
  },
}



// WEBPACK FOOTER //
// ./src/models/dates.js